import { AmountFieldMetadata } from 'models/forms/fields';
import { ErrorWrapper } from 'routes/essential-workspace/components/form/error-wrapper';
import { Amount } from 'routes/essential-workspace/components/form/fields/shared/amount/amount';
import { useFormErrors } from 'routes/essential-workspace/components/form/use-form-errors';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';
export function AmountField({ id, currency = '', isReadOnly, nbDecimals }: AmountFieldMetadata) {
  const [value, setValue] = useFormFieldData<Nullable<number>>(id);

  const { getFieldError } = useFormErrors();
  const fieldError = getFieldError(id);

  return (
    <ErrorWrapper error={fieldError}>
      <Amount
        value={value}
        setValue={setValue}
        currency={currency}
        hasError={fieldError?.severity === 'Error'}
        id={id}
        isReadOnly={isReadOnly}
        nbDecimals={nbDecimals}
        highlightColor={fieldError?.severity === 'Warning' ? 'info' : undefined}
      />
    </ErrorWrapper>
  );
}
